/**
 * Playlist Analytics sagas
 */
import { call, put, takeLatest } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import { httpRequest } from '../../services/http-service';
import { endPoints } from '../../services/endpoints';
import {
  fetchPlaylistAnalytics,
  setPlaylistAnalytics,
  setLoading,
  setError,
} from './playlistAnalyticsSlice';
import { presentLoader, dismissLoader } from './commonSlice';

/**
 * Fetch playlist analytics saga
 */
function* fetchPlaylistAnalyticsSaga(): Generator<any, void, any> {
  try {
    yield put(presentLoader());
    yield put(setLoading(true));

    const response = yield call(httpRequest.get, endPoints.dashboard.playlistAnalytics);

    if (response?.success) {
      yield put(setPlaylistAnalytics(response.data));
    } else {
      toast.error('Failed to fetch playlist analytics');
      yield put(setError('Failed to fetch playlist analytics'));
    }
  } catch (error: any) {
    const message = error?.message || 'Failed to fetch playlist analytics';
    toast.error(message);
    yield put(setError(message));
  } finally {
    yield put(setLoading(false));
    yield put(dismissLoader());
  }
}

export function* playlistAnalyticsSagas(): Generator<any, void, any> {
  yield takeLatest(fetchPlaylistAnalytics, fetchPlaylistAnalyticsSaga);
}

